/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ConnectAppsSettingsType from '@jira/spa-apps__project-settings-connect-apps/src/ProjectSettingsApps.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyConnectAppsSettings: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof ConnectAppsSettingsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-project-settings-connect-apps", jiraSpaEntry: "async-project-settings-connect-apps" */ '@jira/spa-apps__project-settings-connect-apps/src/ProjectSettingsApps.tsx'
			),
		),
	);

const AsyncConnectAppsSettings = (): React.JSX.Element => (
	<LazyPage
		Page={LazyConnectAppsSettings}
		pageId="project-settings-connect-apps"
		shouldShowSpinner={false}
	/>
);

export default AsyncConnectAppsSettings;
